<template>
<router-link style="text-decoration: none;" :to="url">
  <div class="card">
      <img :src="imgsrc" :alt="imgalt"/>
      <div class="content">
          <p>{{title}}</p>
          <div class="card__subtitle">{{subtitle}}</div>
      </div>
  </div>
</router-link>
</template>

<script>
export default{
  props:['imgsrc', 'title', 'subtitle', 'imgalt', 'url'],
  data(){
    return {
        
    }
  },
  computed: {

  },
  methods: {

  },
  created(){
  
  },
  watch: {

  }
}
</script>

<style lang="scss" scoped>

.card {
    display: grid;
    grid-template-rows: auto 1fr;
    min-width: 0;
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
    transition: 0.3s;
    img {
        justify-self: center;
        object-fit: cover;
        width: 100%;
        aspect-ratio: 3 / 2;
    }
    .content {
        padding: 2px 16px;
        margin: 1em 0;
        min-width: 0;
        p {
            font-weight: bold;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        .card__subtitle {
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
        }
    }
}

.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
}

a {
  color: black; 
  font-weight: unset;
}

a:hover {
  color: rgba(0, 111, 179, 0.9);
}
</style>